/**
 * Pagination des écrans de liste.
 *
 * Le serveur ne renvoie qu'une tranche (`items`) et le total du jeu filtré : ce
 * composant est donc le SEUL endroit qui dit à l'utilisateur combien de lignes
 * existent réellement. Il s'affiche même sur une seule page (le décompte vaut
 * l'affichage) ; les boutons n'apparaissent qu'au-delà d'une page.
 *
 * `capped` : sur les écrans dont le filtre dépend d'un champ calculé par Odoo, le
 * serveur lit un ensemble borné. Quand la borne est atteinte, on le dit — c'était
 * exactement le défaut d'avant : des lignes manquantes, en silence.
 */
export default function Pager({
  total, limit, offset, onOffset, unit = ['ligne', 'lignes'], capped, cappedNote,
}: {
  total: number;
  limit: number;
  offset: number;
  onOffset: (offset: number) => void;
  unit?: [string, string];
  capped?: boolean;
  cappedNote?: string;
}) {
  if (total === 0) return null;
  const lastOffset = Math.max(0, Math.floor((total - 1) / limit) * limit);
  const page = Math.floor(offset / limit) + 1;
  const pages = Math.floor(lastOffset / limit) + 1;
  const from = offset + 1;
  const to = Math.min(offset + limit, total);

  return (
    <div className="pager">
      <span>
        {total > limit ? `${from}–${to} sur ${total} ${unit[1]}` : `${total} ${total > 1 ? unit[1] : unit[0]}`}
      </span>
      {total > limit && (
        <>
          <button disabled={offset === 0} onClick={() => onOffset(Math.max(0, offset - limit))}>← Précédent</button>
          <span>Page {page} / {pages}</span>
          <button disabled={offset >= lastOffset} onClick={() => onOffset(offset + limit)}>Suivant →</button>
        </>
      )}
      {capped && (
        <span className="pager-capped" title={cappedNote}>
          ⚠️ lecture plafonnée — {cappedNote ?? 'affinez la recherche pour voir le reste'}
        </span>
      )}
    </div>
  );
}
